import React from 'react'
import {Tiers} from './Tiers'
import {ComparePlanFeatures} from './ComparePlanFeatures'

export function PricingTiers() {
  return (
    <>
      <Tiers page='pricing' showPopularFlag={false} customClass={'container'} />

      <ComparePlanFeatures page='pricing' />
    </>
  )
}
